import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import ChangeNumberForm from './ChangeNumberForm';
import { FieldEnum } from 'Common/FieldEnum';
class StudentNumberModalContainer extends Component {
  state = {
    isValid: false,
  };
  submitStudentNumber = values => {
    let number = {
      OldStudentNumber: values['studentId'],
      NewStudentNumber: values[FieldEnum.Id],
    };
    this.props.saveStudentNumber(number);
  };

  render() {
    const {
      showStudentNumberModal,
      studentModalData,
      onClose,
      loading,
    } = this.props;
    return (
      <div>
        <Modal
          open={showStudentNumberModal}
          onClose={onClose}
          closeIcon
          size={'small'}
          closeOnRootNodeClick={false}
        >
          <Header
            content={`Change Student Number - ${studentModalData.FirstName} ${
              studentModalData.LastName
            }`}
            icon={'subscript'}
          />
          <Modal.Content className="p-t-0">
            <ChangeNumberForm
              initialValues={{
                studentId: studentModalData.Id,
              }}
              ref={instance => {
                this.form = instance;
              }}
              setIsValid={isValid => {
                this.setState({ isValid });
              }}
              onSubmit={this.submitStudentNumber}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() => this.form.submit()}
              inverted
              color="orange"
              size="big"
              content="Save"
              disabled={!this.state.isValid || loading}
              type="submit"
              loading={loading}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = () => {
  return {};
};

export const StudentNumberModal = connect(
  mapStateToProps,
  null
)(StudentNumberModalContainer);



// WEBPACK FOOTER //
// ./src/pages/accountsetup/components/StudentNumberModal.js